export enum HumanType
{
    Unset = "Unset",
    Customer = "Customer",
    Curier = "Curier",
    Friend = "Friend",
    Family = "Family",
    Driver = "Driver"
}
